import { ApiVersionUnion } from './types'

export const CACHE_TIME_LIFE = 0.001

export const apiPath = '/api'

export const currentApiVersion: ApiVersionUnion = 'v1'
